import React, { useState, useContext } from "react";
import {
  manageMapperStore,
  setManageMapperToastInfo,
  setMapperPostResponse,
} from "../../../contexts";
import { useDeepEffect, useRouterParams } from "../../../abstracts";
import { getPathWithParam, MANAGE_MAPPER_ROUTES, ROUTES } from "../../../utils";
import {
  FormLeaveGuard,
  LoaderWrapper,
  ManageMapperLayout,
  WarningModal,
} from "../../../components";
import MapAndTransformOutputFixedWidthContainer from "./MapAndTransformOutputFixedWidthContainer";
import MapAndTransformOutputExcelContainer from "./MapAndTransformOutputExcelContainer";
import { get, isEmpty } from "lodash";
import { Button } from "react-bootstrap";
import { MANAGE_MAPPER_POST_API_ERROR } from "./../../../contexts/reducers/manage-mapper/actions";
import {
  onSaveMapAndTransformOutput,
  fixedWidthOutputMappingSave,
} from "./../../../services/mapper/index";

export const getExtension = (format) => {
  switch (format) {
    case 1:
      return ".csv";
    case 2:
      return ".txt";
    case 3:
      return ".xlsx";
    default:
      return ".xlsx";
  }
};

const MapAndTransformOutputContainer = (props) => {
  const { state, dispatch } = useContext(manageMapperStore);
  const { history } = props;
  const { profileId, mapType } = useRouterParams();
  const outputSections =
    (profileId && get(state, "api.data.fixedWidthOutputSections")) || [];
  const [sections, setSections] = useState([]);
  const apiData = (profileId && get(state, "api.data", {})) || {};
  const [mappedData, setMappedData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const dataModel = get(state, "api.data.dataModel", "");
  const [loading, setLoading] = useState(false);

  useDeepEffect(() => {
    setSections(outputSections);
  }, [outputSections]);

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () => {
        setModalVisible(true);
      },
    },

    {
      label: "Next",
      variant: "primary",
      type: "submit",
      onClick: () => {
        onFormSubmit();
      },
    },
  ];

  const navigateToMapperHomePage = () => {
    history.push(
      getPathWithParam({
        path: `${ROUTES.MAPPER_HOME}`,
      })
    );
  };

  const onFormSubmit = () => {
    setLoading(true);
    let mappingObjectMaps = mappedData.map((item, index) => {
      return {
        ...item,
        mappingOutputProfileId: profileId ?? 0,
        sortOrder: index,
      };
    });
    get(apiData, "format") == 1 || get(apiData, "format") == 3
      ? onSaveMapAndTransformOutput(
          { id: profileId ?? 0, mappingObjectMaps: mappingObjectMaps },
          dispatch,
          state
        )
          .then((response) => {
            if (response) {
              let res = {
                ...response,
                mappingObjectMaps: response?.mappingObjectMaps.filter(
                  (_) => !_.isDeleted
                ),
              };
              dispatch(setMapperPostResponse(res));
              dispatch(
                setManageMapperToastInfo({
                  showToast: true,
                  toastMessage: "Data saved successfully",
                })
              );
              history.push(
                getPathWithParam({
                  path: `${MANAGE_MAPPER_ROUTES.VERIFY_AND_MAP_OUTPUT}/${mapType}/${profileId}`,
                })
              );
              setLoading(false);
            }
          })
          .catch((error) => {
            setLoading(false);
            dispatch({
              type: MANAGE_MAPPER_POST_API_ERROR,
              payload: "Something went wrong! please try again.",
            });
          })
      : isEmpty(sections)
      ? fixedWidthOutputMappingSave({
          id: profileId ?? 0,
          fixedWidthOutputSections: sections,
        })
          .then((response) => {
            setLoading(false);
            dispatch(setMapperPostResponse(response));
            dispatch(
              setManageMapperToastInfo({
                showToast: true,
                toastMessage: "Data saved successfully",
              })
            );
            history.push(
              getPathWithParam({
                path: `${MANAGE_MAPPER_ROUTES.VERIFY_AND_MAP_OUTPUT}/${mapType}/${profileId}`,
              })
            );
          })
          .catch((error) => {
            setLoading(false);
            dispatch({
              type: MANAGE_MAPPER_POST_API_ERROR,
              payload: "Something went wrong! please try again.",
            });
          })
      : history.push(
          getPathWithParam({
            path: `${MANAGE_MAPPER_ROUTES.VERIFY_AND_MAP_OUTPUT}/${mapType}/${profileId}`,
          })
        );
  };

  return (
    <ManageMapperLayout buttons={buttons} layoutHeader="Map & transform">
      <LoaderWrapper isLoading={loading}>
        <div className="m-2 p-2"></div>
        <FormLeaveGuard
          showModal={modalVisible}
          handleConfirmClick={() => navigateToMapperHomePage()}
          handleCancelClick={() => setModalVisible(false)}
        />
        {get(apiData, "format") == 2 ? (
          <MapAndTransformOutputFixedWidthContainer
            sections={sections}
            setSections={setSections}
            dataModel={dataModel}
          />
        ) : (
          <MapAndTransformOutputExcelContainer
            mappedData={mappedData}
            setMappedData={setMappedData}
            dataModel={dataModel}
          />
        )}
      </LoaderWrapper>
    </ManageMapperLayout>
  );
};

export default MapAndTransformOutputContainer;
